module.exports = __webpack_public_path__ + "static/plotly-bundle-11d11407fae9c5b3f095a9128a1ec6c8.png";